// بازه‌های زمانیِ شمسی برای داشبوردِ زنجیره تأمین
// خروجی هر preset: { date_from, date_to } به‌صورتِ ISOِ میلادی (یا null برای «کل»)
import {
  currentJalali, jalaaliToISO, jalaaliMonthLength, todayISO, JALALI_MONTHS,
} from "../../utils/dateUtils";
import { faNum } from "../../utils/faNumberFormat";

// جمعِ شمسی روی (سال، ماه) با delta (ممکن است منفی) → {jy, jm}
function addJ(jy, jm, delta) {
  const total = jy * 12 + (jm - 1) + delta;
  return { jy: Math.floor(total / 12), jm: (((total % 12) + 12) % 12) + 1 };
}
const monthStartISO = (jy, jm) => jalaaliToISO(jy, jm, 1);
const monthEndISO = (jy, jm) => jalaaliToISO(jy, jm, jalaaliMonthLength(jy, jm));
const fa = (n) => faNum(Number(n), { useGrouping: false });

export const PERIOD_PRESETS = [
  { key: "this_month", label: "این ماه" },
  { key: "last_month", label: "ماه قبل" },
  { key: "last_2", label: "۲ ماه اخیر" },
  { key: "last_3", label: "۳ ماه اخیر" },
  { key: "season", label: "فصلِ جاری" },
  { key: "ytd", label: "از ابتدای سال" },
  { key: "this_year", label: "امسال" },
  { key: "all", label: "کل" },
];

const SEASON_NAME = (m) => (m <= 3 ? "بهار" : m <= 6 ? "تابستان" : m <= 9 ? "پاییز" : "زمستان");

/** preset → { date_from, date_to, label } (تاریخ‌ها ISOِ میلادی؛ label شمسیِ خوانا) */
export function periodRange(key) {
  const { year: cy, month: cm } = currentJalali();
  const today = todayISO();
  const monthName = (m) => JALALI_MONTHS[(m - 1 + 12) % 12];

  switch (key) {
    case "this_month":
      return { date_from: monthStartISO(cy, cm), date_to: monthEndISO(cy, cm),
        label: `${monthName(cm)} ${fa(cy)}` };
    case "last_month": {
      const p = addJ(cy, cm, -1);
      return { date_from: monthStartISO(p.jy, p.jm), date_to: monthEndISO(p.jy, p.jm),
        label: `${monthName(p.jm)} ${fa(p.jy)}` };
    }
    case "last_2": {
      const p = addJ(cy, cm, -1);
      return { date_from: monthStartISO(p.jy, p.jm), date_to: today,
        label: `${monthName(p.jm)} ${fa(p.jy)} تا کنون` };
    }
    case "last_3": {
      const p = addJ(cy, cm, -2);
      return { date_from: monthStartISO(p.jy, p.jm), date_to: today,
        label: `${monthName(p.jm)} ${fa(p.jy)} تا کنون` };
    }
    case "season": {
      const s = cm <= 3 ? 1 : cm <= 6 ? 4 : cm <= 9 ? 7 : 10;
      return { date_from: monthStartISO(cy, s), date_to: today,
        label: `${SEASON_NAME(cm)} ${fa(cy)}` };
    }
    case "ytd":
      return { date_from: monthStartISO(cy, 1), date_to: today,
        label: `از فروردین ${fa(cy)} تا کنون` };
    case "this_year":
      return { date_from: monthStartISO(cy, 1), date_to: monthEndISO(cy, 12),
        label: `سالِ ${fa(cy)}` };
    case "all":
    default:
      return { date_from: null, date_to: null, label: "همهٔ زمان‌ها" };
  }
}
